import * as React from 'react'
import { TableContainer, Table, TableHead, TableRow, TableBody, Paper, TableCell, MenuItem, Select, withStyles, Theme, createStyles, Button, Box, Tabs, Tab, AppBar, DialogTitle, DialogContent, Dialog, DialogActions, TextField } from '@material-ui/core'

import NationalCodeSelect from "../../components/NationalCodeSelect"
import axios from 'axios'
import { useFeedback } from '../../components/Feedback';
import useRefresh from '../../hooks/useRefresh';
import { setCourseStatus, listCourse, getCourseCollection, pushCourse, giveCourse } from '../../utils/api';
import { useHistory } from 'react-router';
import { useQuery } from 'react-query';
import { CourseCategory } from '../../constants';
import TabPanel from '../../components/TabPanel';
import moment from 'moment';
import ShareConfigDialog from '../../components/ShareConfigDialog';

const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }),
)(TableCell);

const Course = () => {
    const [courseType, setCourseType] = React.useState('all')
    const { data: courses, refetch } = useQuery<Course[]>(['listCourse', courseType], () => listCourse(undefined, courseType))
    const { data: collections,refetch: refetchCollection } = useQuery<CourseCollection[]>('getCourseCollection', () => getCourseCollection())
    const history = useHistory()

    const { showToast } = useFeedback()
    const [tabIndex, setTabIndex] = React.useState(0)
    const [openPush, setOpenPush] = React.useState(false)
    const [pushContent, setPushContent] = React.useState({
        id: '',
        title: '',
        content: '',
        type: 'course'
    })
    const [configKey,setConfigKey] = React.useState<string>()
    const [openGive, setOpenGive] = React.useState(false)
    const [giveContent, setGiveContent] = React.useState({
        id: '',
        nationalCode:'86',
        mobile: '',
        type: 'course'
    })

    useRefresh(() => {
        refetch()
    })

    const handleStatusChange = (id: string) => (event: React.ChangeEvent<{ value: unknown }>) => {
        setCourseStatus(event.target.value as string, id).then(res => {
            refetch()
        }).catch(err => {
            showToast('修改失败')
            refetch()
        })
    }

    const handleTabIndexChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTabIndex(newValue);
    };

    const handleShowPush = (id: string, type: 'course' | 'collection') => () => {
        setPushContent({ ...pushContent, id: id, type: type })
        setOpenPush(true)
    }

    const handlePushContentChange = (key: 'title' | 'content') => (event: React.ChangeEvent<HTMLInputElement>) => {
        setPushContent({ ...pushContent, [key]: event.target.value })
    }

    const handlePush = () => {
        if (!pushContent.title) {
            showToast('请输入消息标题')
            return;
        }
        if (!pushContent.content) {
            showToast('请输入消息内容')
            return;
        }
        pushCourse(pushContent.id, pushContent.type, pushContent.title, pushContent.content).then(res => {
            showToast('推送消息成功')
            setPushContent({
                id: '',
                title: '',
                content: '',
                type: 'course'
            })
            setOpenPush(false)
        }).catch(e => {
            showToast('推送消息失败')
        })
    }

    const handleGivePush= (id: string, type: 'course' | 'collection') => () => {
        setGiveContent({ ...giveContent, id: id, type: type })
        setOpenGive(true)
    }
    const handleGiveContentChange = (key: 'mobile'|'nationalCode') => (event: React.ChangeEvent<HTMLInputElement>) => {
        setGiveContent({ ...giveContent, [key]: event.target.value })
    }
    const handleGive = () => {
        const mobile=giveContent.mobile
        if (!mobile) {
            showToast('请输入手机号')
            return;
        }
     
        if (!(giveContent.nationalCode=='86'?/^1[3456789]\d{9}$/.test(mobile):/^\d{6,}$/.test(mobile))) {
            showToast('手机号格式不正确')
            return;
        }
        axios.post('/api/admin/client/search', { mobile}).then(res => {
            if (res.data.length == 0) {
                showToast('用户不存在')
            } else { 
                const userId = res.data[0].id
                
                giveCourse(userId, giveContent.id,giveContent.type).then(res => {
                    showToast('赠送课程成功')
                    setGiveContent({
                        id: '',
                        nationalCode:giveContent.nationalCode,
                        mobile: '',
                        type: 'course'
                    })
                    setOpenGive(false)
                }).catch(e => {
                    showToast('赠送课程失败')
                })
            }
           
        })
       
    }

    const computedCourseType = (course: Course) => {
        const types = []
        if (course.type === 'free' && course.free_begin_time && course.free_end_time) {
            if (moment().isAfter(course.free_end_time)) {
                types.push(<span style={{backgroundColor: '#d1d1d1'}}>{`限时免费(${moment(course.free_begin_time).format('MM/DD HH:mm')}至${moment(course.free_end_time).format('MM/DD HH:mm')})`}</span>)
            } else {
                types.push(`限时免费(${moment(course.free_begin_time).format('MM/DD HH:mm')}至${moment(course.free_end_time).format('MM/DD HH:mm')})`)
            }
        } else if (course.type === 'free' && !course.free_begin_time && !course.free_end_time) {
            types.push(<div>限时免费(长期)</div>)
        }
        if (course.vip_free) {
            types.push(<div>会员免费看</div>)
        }
        return types.map(i => i)
    }

    const PlanTab = withStyles((theme: Theme) =>
        createStyles({
            root: {
                textAlign: 'left',
                color: '#333',
                '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText
                },

            },
            selected: {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            }
        })
    )(Tab)

    return <React.Fragment>
        <Box mb={2}>
            <Button onClick={() => window.open('/admin/course/add', '_blank')}>添加课程</Button>
            <Button style={{ marginLeft: '8px' }} onClick={() => window.open('/admin/collection/add', '_blank')}>添加合辑</Button>
        </Box>

        <AppBar style={{ backgroundColor: '#f1f1f1' }} position="static">
            <Tabs value={tabIndex} onChange={handleTabIndexChange}>
                <PlanTab label="课程" />
                <PlanTab label="合辑" />
            </Tabs>
        </AppBar>

        <TabPanel index={0} value={tabIndex}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell width="300px">课程名称</StyledTableCell>
                            <StyledTableCell align="center">视频</StyledTableCell>
                            <StyledTableCell align="center">分类</StyledTableCell>
                            <StyledTableCell align="center">
                                <TextField
                                    select
                                    value={courseType}
                                    onChange={event => setCourseType(event.target.value)}
                                    SelectProps={{ style: { color: '#fff' }, renderValue: value => value === 'all' ? '类型' : '限时免费' }}
                                    InputProps={{ disableUnderline: true }}
                                    inputProps={{ style: { color: '#fff' } }}>
                                    <MenuItem value="all">全部</MenuItem>
                                    <MenuItem value="free">限时免费</MenuItem>
                                </TextField>
                            </StyledTableCell>
                            <StyledTableCell align="center">价格</StyledTableCell>
                            <StyledTableCell align="center">上线状态</StyledTableCell>
                            <StyledTableCell align="center">操作</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {courses?.map(course => <TableRow key={course.id}>
                            <TableCell width="500">{course.name}</TableCell>
                            <TableCell align="center">{course.url ? <Button size="small" variant="text" href={course.url} target="_blank">预览视频</Button> : '未上传'}</TableCell>
                            <TableCell align="center">{course.category && CourseCategory[+course.category]}</TableCell>
                            <TableCell align="center">{computedCourseType(course)}</TableCell>
                            <TableCell align="center">{course.price}元</TableCell>
                            <TableCell align="center">
                                <Select style={{ backgroundColor: `${course.status === 'online' ? '#fff' : '#d1d1d1'}` }} onChange={handleStatusChange(course.id)} value={course.status}>
                                    <MenuItem value="online">上线</MenuItem>
                                    <MenuItem value="offline">下线</MenuItem>
                                </Select>
                            </TableCell>
                            <TableCell align="center">
                                <Button size="small" onClick={() => window.open(`/admin/course/edit/${course.id}`, '_blank')}>编辑</Button>
                                <Button size="small" style={{ marginLeft: '8px' }} onClick={()=> setConfigKey(course.id)}>分享设置</Button>
                                {course.status === 'online' && <Button size="small" style={{ marginLeft: '8px' }} onClick={handleShowPush(course.id, 'course')} >推送通知</Button>}
                                {course.status === 'online' && <Button size="small" style={{ marginLeft: '8px' }} onClick={handleGivePush(course.id, 'course')} >赠送课程</Button>}
                                <Button size="small" style={{ marginLeft: '8px' }} onClick={() => window.open(`/admin/course/sort/${course.id}`, '_blank')}>设置排序</Button>
                            </TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </TabPanel>

        <TabPanel index={1} value={tabIndex}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>课程名称</StyledTableCell>
                            <StyledTableCell align="center">简介</StyledTableCell>
                            <StyledTableCell align="center">讲师</StyledTableCell>
                            <StyledTableCell align="center">价格</StyledTableCell>
                            <StyledTableCell align="center">操作</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collections?.map(collection => <TableRow key={collection.id}>
                            <TableCell width="500">{collection.name}</TableCell>
                            <TableCell align="center">{collection.intro}</TableCell>
                            <TableCell align="center">{collection.lecturer}</TableCell>
                            <TableCell align="center">{collection.price}元</TableCell>
                            <TableCell align="center">
                                <Button size="small" onClick={() => window.open(`/admin/collection/edit/${collection.id}`, '_blank')}>编辑</Button>
                                <Button size="small" style={{ marginLeft: '8px' }} onClick={()=> setConfigKey(collection.id)}>分享设置</Button>
                                <Button size="small" style={{ marginLeft: '8px' }} onClick={handleShowPush(collection.id, 'collection')} >推送通知</Button>
                            </TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </TabPanel>


        <Dialog open={openPush} onClose={() => setOpenPush(false)}>
            <DialogTitle>推送通知</DialogTitle>
            <DialogContent>
                <Box>
                    <TextField value={pushContent.title} onChange={handlePushContentChange('title')} label="通知标题" variant="outlined" size="small" fullWidth />
                    <TextField value={pushContent.content} onChange={handlePushContentChange('content')} label="通知内容" variant="outlined" size="small" fullWidth style={{ marginTop: '24px' }} rowsMax={2} rows={2} multiline />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={() => setOpenPush(false)}>取消</Button>
                <Button onClick={handlePush}>发送</Button>
            </DialogActions>
        </Dialog>
        <Dialog open={openGive} onClose={() => setOpenGive(false)}>
            <DialogTitle>赠送课程</DialogTitle>
            <DialogContent>
               
                <Box display="flex" width="420" justifyContent="center" alignItems="center">
                    <TextField
                        variant="outlined"
                        size="small"
                        label="手机号"
                        fullWidth
                        value={giveContent.mobile}
                        onChange={handleGiveContentChange('mobile')}
                        InputProps={{ startAdornment: <NationalCodeSelect style={{ height: '36px', width: '90px' }} onChange={handleGiveContentChange('nationalCode')} value={giveContent.nationalCode} /> }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={() => setOpenGive(false)}>取消</Button>
                <Button onClick={handleGive}>赠送</Button>
            </DialogActions>
        </Dialog>
        <ShareConfigDialog open={Boolean(configKey)} type={tabIndex === 0 ? 'course': 'collection'} typeKey={configKey} onClose={(save?: boolean)=> {
            if(tabIndex === 0){
                refetch()
            }else{
                refetchCollection()
            }
            setConfigKey(undefined)
        }}/>
    </React.Fragment>
}

export default Course